const styles = theme => ({
  background: {
    backgroundImage: "radial-gradient(#999999, #666666, black)",
    margin: '0 auto',
    height: '100vh',
    width: '100vw',
  },
  displayMessage: {
    display: 'inline-block',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: 1.25,
    marginBottom: 5,
    textTransform: 'uppercase',
  },
  formContainer: {
    textAlign: 'center',
    width: '100%',
    height: 150
  },
  loginModal: {
    textAlign: 'center',
    width: 520,
    minHeight: 300,
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #000',
    borderRadius: 5,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  logo: {
    verticalAlign: 'middle',
    height: 50,
    marginBottom: 25,
  },
  majorButton: {
    color: 'white',
    width: '100%',
  },
  marginTop30: {
    marginTop: 30,
  },
  marginTop60: {
    marginTop: 60,
  },
  minorButton: {
    width: '100%',
  },
  modalPlacement: {
    alignItems: 'center',
    display: 'flex',
    height: '100vh',
    justifyContent: 'center',
  },
  textFields: {
    left: -30,
    marginBottom: 15,
    position: 'relative',
    width: 515,
  },
})

export default styles
